import React, { useState } from "react";
import { Input, Button, Upload, Form, message as antdMessage } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import styles from "./SupportNewMessage.module.css";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import { postSupportMessage } from "../../Api/BarestServices";
import { errorToast, succToast } from "../../Toast/Toast";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

// Helper function to convert a file to Base64
const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

const SupportNewMessage = () => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
    const history=useHistory()
  const handleFileChange = ({ fileList }) => setFileList(fileList);

  const onFinish = async (values) => {
    try {
      const fileBase64 = fileList.length > 0 ? await getBase64(fileList[0].originFileObj) : null;

      // Prepare the data
      const jsonData = {
        support_id:"0",
        department:"0",
        reply_to:"0",
        order_id: values.order_id,
        title: values.title,
        message: values.message,
        files: fileBase64? [fileBase64]  : [],
      };
      postSupportMessage(jsonData,(succ,res)=>{
        if(succ){
            if(res.status===1){
                succToast('پیام شما با موفقیت ثبت شد')
                setFileList([]);
                setTimeout(() => {
                    history.push(`supportchat/${res.support_id}`)
                }, 1000);
            }else{
                errorToast(res.message)
            }
        }else{
            console.error(res)
        }
      })

    } catch (error) {
      console.error("Error generating Base64 or JSON:", error);
    }
  };

  return (
    <div className={styles.formContainer}>
      <BurgerMenuTitle title="شروع پیام به پشتیبانی" />
      <Form form={form} onFinish={onFinish} layout="vertical" className={styles.formHolder}>
        <Form.Item
          name="order_id"
          label="شماره سفارش"
          rules={[{ required: true, message: "لطفا شماره آیدی را وارد کنید!" }]}
        >
          <Input placeholder="شماره آیدی را وارد کنید" />
        </Form.Item>

        <Form.Item
          name="title"
          label="عنوان"
          rules={[{ required: true, message: "لطفا عنوان را وارد کنید" }]}
        >
          <Input placeholder="عنوان پیغام..." />
        </Form.Item>

        <Form.Item
          name="message"
          label="پیام"
          rules={[{ required: true, message: "پیام خود را وارد کنید" }]}
        >
          <Input.TextArea rows={4} placeholder="متن پیام شما..." />
        </Form.Item>

        <Form.Item label="آپلود فایل">
          <Upload
            beforeUpload={() => false} // Prevent auto-upload
            fileList={fileList}
            onChange={handleFileChange}
            accept=".png,.jpg,.jpeg,.pdf,.docx,.zip"
          >
            <Button icon={<UploadOutlined />}>آپلود فایل</Button>
          </Upload>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ background: "rgb(187, 0, 134)", border: "none", width: "100%" }}>
            شروع چت
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default SupportNewMessage;
